export const COGNITO_ATTRIBUTES = [
  { Name: "email", required: true },
  { Name: "custom:saml_unique_id", required: true },
  { Name: "custom:practitioner_id", required: false },
  { Name: "name", required: false },
  { Name: "family_name", required: false },
  { Name: "given_name", required: false },
  { Name: "custom:role", required: true },
  { Name: "birthdate", required: false },
  { Name: "gender", required: false },
  { Name: "address", required: false },
  { Name: "custom:agentId", required: false },
  // { Name: "city", required: false },
  // { Name: "province", required: false },
  // { Name: "postalcode", required: false },
  // { Name: "country", required: false }
];
